import { useTranslation } from 'react-i18next';
import PicturizedImage, { type PicturizedImageProps } from '@/components/common/picturized-image';
import { transformGlyphCode } from '@/utils/language-code';

type LogoVariant = 'full' | 'simple';

interface Props {
  variant: LogoVariant;
  fetchPriority?: 'high' | 'low' | 'auto';
  as?: PicturizedImageProps['as'];
  className?: string;
}

export function BrandLogo({ className, as, fetchPriority, variant }: Props) {
  const { i18n } = useTranslation();
  const glyphCode = transformGlyphCode(i18n.resolvedLanguage);

  let url = variant === 'full' ? 'logo-full' : 'logo';
  url += `.${glyphCode}`;
  const picture: Picture = {
    img: { src: `/${url}.png` },
    sources: {
      avif: `/${url}.avif`,
      webp: `/${url}.webp`,
    },
  };

  return (
    <PicturizedImage
      fetchPriority={fetchPriority}
      as={as}
      picture={picture}
      className={className}
    />
  );
}
